
import React from "react";
import ReactDOM from "react-dom/client";
import { useForm } from "react-hook-form";
import {  Modal } from "react-bootstrap";
import { CustomFormInput } from "../components/CustomFormInput";
import { ROUTES } from "../routes/Routes";
import { getNavigate } from "../helper/utility";
import trackLocation from "../assets/icons/track_location.svg";

type TrackOrderDialogProps = {
    onClose: () => void;
};

const TrackOrderDialog: React.FC<TrackOrderDialogProps> & {
    show: () => void;
} = ({ onClose }) => {
    const navigate = getNavigate();
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm<{ orderId: string }>();

    const onSubmit = (data: { orderId: string }) => {
        navigate(ROUTES.ORDER_DETAILS.path.replace(":orderId", data.orderId));
        onClose();
    };

    return (
        <Modal show={true} onHide={onClose} centered className="custom-modal">
            <Modal.Header closeButton>
                <Modal.Title>Track Order</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="custom-track-model">
                        <img src={trackLocation} alt="track" className="custom-track-model-img"/>
                        <CustomFormInput
                            label=""
                            controlId="orderId"
                            placeholder="Enter Order ID (eg: SOS-0995523411)"
                            register={register}
                            error={errors.orderId}
                            fullWidth={true}
                           // value={"SOS-1759899584782"}
                        />
                        <button type="submit" className="custom-primary-button" style={{width:"80%", marginBottom:"30px"}}>
                            Track
                        </button>
                    </div>

                </form>
            </Modal.Body>
        </Modal>
    );
};

TrackOrderDialog.show = () => {
    const existingModal = document.getElementById("track-order-model");
    if (existingModal) {
        return;
    }
    const modalContainer = document.createElement("div");
    modalContainer.id = "track-order-model";
    document.body.appendChild(modalContainer);
    const root = ReactDOM.createRoot(modalContainer);

    const closeModal = () => {
        root.unmount();
        document.body.removeChild(modalContainer);
    };

    root.render(
        <TrackOrderDialog
            onClose={closeModal}
        />
    );
};

export default TrackOrderDialog;
